
import ReactDOM from 'react-dom/client';
import Oauth from './components/oauth/Oauth';
import SignIn from './components/auth/SignIn';
import SignUp from './components/auth/SignUp';
import Authorize from './components/oauth/Authorize';
import VerifyEmail from './components/auth/VerifyEmail';
import MultiFactor from './components/auth/MultiFactor';
import ResetPassword from './components/auth/ResetPassword';
import SelectAccount from './components/oauth/SelectAccount';
import ForgotPassword from './components/auth/ForgotPassword';
import { createBrowserRouter, RouterProvider, useRouteError } from "react-router-dom";
import './assets/css/index.css';

export function RootBoundary() {

    const error = useRouteError() as any;
    window.location = "/?error=" + error.message as any;

    return undefined;

}

const router = createBrowserRouter([
    { path: "*", element: <SignIn />, errorElement: <RootBoundary /> },
    { path: "/oauth", element: <Oauth />, errorElement: <RootBoundary /> },
    { path: "/sign-up", element: <SignUp />, errorElement: <RootBoundary /> },
    { path: "/fa", element: <MultiFactor />, errorElement: <RootBoundary /> },
    { path: "/verify-email", element: <VerifyEmail />, errorElement: <RootBoundary /> },
    { path: "/oauth/authorize", element: <Authorize />, errorElement: <RootBoundary /> },
    { path: "/reset-password", element: <ResetPassword />, errorElement: <RootBoundary /> },
    { path: "/forgot-password", element: <ForgotPassword />, errorElement: <RootBoundary /> },
    { path: "/oauth/select-account", element: <SelectAccount />, errorElement: <RootBoundary /> },
]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    //<React.StrictMode>
    <RouterProvider router={router} />
    //</React.StrictMode>
);

